const generateAgeOptions = (min: number, max: number) =>
  Array.from({ length: max - min + 1 }, (_, i) => {
    const age = min + i
    return { label: String(age), value: String(age) } as const
  })

export const USERS_FILTRATION = {
    AGE_FROM: generateAgeOptions(18, 100),

    AGE_TO: generateAgeOptions(18, 100),

    STATUS: [
        { label: "Все", value: "all" },
        { label: "В поиске проекта", value: "looking_project" },
        { label: "Открыт предложениям", value: "open_to_offers" },
        { label: "Занят", value: "busy" },
    ] as const,

    COMPETENCIES: [
        { label: "Все", value: "all" },
        { label: "Управление / Менеджмент", value: "management" },
        { label: "Психология / Коучинг", value: "psychology" },
        { label: "Маркетинг / PR", value: "marketing" },
        { label: "IT / Разработка", value: "it" },
        { label: "Юриспруденция", value: "legal" },
        { label: "Дизайн / Креатив", value: "design" },
        { label: "Волонтерство", value: "volunteer" },
    ] as const,
}